'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bemReactCore = require('bem-react-core');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _bemReactCore.declMod)({ type: 'js' }, {
    block: 'b-statcounter',
    elem: 'metrika',
    willInit: function willInit(params) {
        this.state = {
            params: params
        };
    },
    didMount: function didMount() {
        this.__self.loadMetrika();
        this.addCounter();
    },
    addCounter: function addCounter() {
        var counter = this.state.params.counter,
            metrikaCallbacks = window['yandex_metrika_callbacks'] || (window['yandex_metrika_callbacks'] = []),
            setCounter = function setCounter() {
            window['yaCounter' + counter] = new Ya.Metrika(_extends({}, counter));
        };


        if (!counter) {
            throw new Error(['JSERR_incorrectID', 'block: b-statcounter__metrika', 'method: addCounter'].join('\n'));
        }

        this.__self.haveMetrika() ? setCounter() : metrikaCallbacks.push(setCounter);
    },

    tag: 'i',
    // Атрибуты не нужны, т.к. вызываем счетчик через js
    attrs: null
}, {
    haveMetrika: function haveMetrika() {
        return window && window.Ya && Ya.Metrika; // eslint-disable-line no-undef
    },
    loadMetrika: function loadMetrika() {
        if (!this.haveMetrika()) {
            var script = document.createElement('script');

            script.src = 'https://mc.yandex.ru/metrika/watch.js';
            script.async = true;

            document.body.appendChild(script);
        }

        this.loadMetrika = function () {};
    },

    propTypes: {
        counter: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
            id: _propTypes2.default.string.isRequired,
            enableAll: _propTypes2.default.bool
        })])
    },
    defaultProps: {
        counterParams: {
            enableAll: true
        }
    }
});